import React, { useState, useEffect } from 'react';
import { FaSteamSymbol, FaSignOutAlt, FaDiscord } from 'react-icons/fa';
import { MdAccountBox } from "react-icons/md";

import './SteamAuthButton.css';

const SteamAuthButton: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/status`, { credentials: 'include' })
            .then(response => response.json())
            .then(data => {
                setIsAuthenticated(data.isAuthenticated);
            })
            .catch(error => {
                console.error('Error fetching auth status:', error);
                setIsAuthenticated(false);
            });
    }, []);

    const handleSteamLogin = () => {
        window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth/login`;
    };

    const handleLogout = () => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/logout`, { credentials: 'include' })
            .then(() => {
                setIsAuthenticated(false);
            })
            .catch(error => console.error('Error logging out:', error));
    };

    if (isAuthenticated === null) {
        return null;
    }

    return (
        <div>
            {isAuthenticated ? (
                <>
                    <div className='flex'>
                        <a
                            href="https://discord.gg/NCXhd9wZat"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-gradient-to-r from-sky-700 to-sky-900 px-2.5 py-2 mr-2 rounded-md shadow-md hover:shadow-[0_0_10px_2px_rgba(56,189,248,0.5)] transition duration-300"
                        >
                            <FaDiscord size={24}/>
                        </a>
                        <button
                            onClick={() => window.location.href = '/profile'}
                            className="bg-gradient-to-r from-sky-700 to-sky-900 px-2.5 py-2 mr-2 rounded-md shadow-md hover:shadow-[0_0_10px_2px_rgba(56,189,248,0.5)] transition duration-300" style={{ fontFamily: 'Montserrat, serif' , fontWeight: 500}}
                        >
                            <MdAccountBox size={24}/>
                        </button>
                        <button
                            onClick={handleLogout}
                            className="bg-gradient-to-r from-[#970808] to-[#780606] px-3 py-2 mr-2 rounded-md shadow-md hover:shadow-[0_0_10px_2px_rgba(255,25,25,0.5)] transition duration-300" style={{ fontFamily: 'Montserrat, serif' , fontWeight: 500}}
                        >
                            <FaSignOutAlt size={20} className="text-white" />
                        </button>
                    </div>
                </>
            ) : (
                <button
                    onClick={handleSteamLogin}
                    className="flex items-center bg-gradient-to-r from-sky-700 to-sky-900 text-white font-bold px-5 py-2 rounded shadow-md hover:shadow-[0_0_10px_2px_rgba(56,189,248,0.5)] transition duration-300"
                >
                    <span className="mr-3">Login with Steam</span>
                    <FaSteamSymbol size={24} />
                </button>
            )}
        </div>
    );
};

export default SteamAuthButton;